import { BellStatus, BellStatusMinified, ConfigStatus, MarkerTime, ScheduledRing } from "./constants";

export class Utils {
  public static   mapPayloadToConfigStatus(payload: string): ConfigStatus{
    const parsedPayload: BellStatusMinified = JSON.parse(payload)
    const bellStatus: ConfigStatus = new ConfigStatus();
    bellStatus.isRinging = parsedPayload.r;
    bellStatus.speed = parsedPayload.sp;
    bellStatus.minMovingSpeed = parsedPayload.mSp;
    bellStatus.slowSpeed = parsedPayload.slSp;
    bellStatus.reverseSpeed = parsedPayload.rSp;
    bellStatus.deviceTime = parsedPayload.tm;
    bellStatus.schedulerCheckInterval = parsedPayload.schInt;
    bellStatus.initPoint = parsedPayload.initPt;
    bellStatus.hitPoint = parsedPayload.hitPt;
    bellStatus.screenTimeout = parsedPayload.scrTime;
    bellStatus.screenPin = parsedPayload.scrPin;
    bellStatus.temperature = parsedPayload.temp;
    bellStatus.humidity = parsedPayload.hum;
    return bellStatus;
  }

  public static  mapPayloadToStatus(payload: string): BellStatus{
    const parsedPayload: BellStatusMinified = JSON.parse(payload)
    const bellStatus: BellStatus = new BellStatus();
    bellStatus.isRinging = parsedPayload.r;
    bellStatus.patternId = parsedPayload.ptId;
    bellStatus.scheduleId = parsedPayload.schId;
    return bellStatus;
  }

  static compareRailwayTime(time1:MarkerTime, time2:MarkerTime){
    try{
      const hour1 = Number((time1.split(':'))[0])
      const min1 = Number((time1.split(':'))[1])
      const hour2 = Number((time2.split(':'))[0])
      const min2 = Number((time2.split(':'))[1])
      if(hour1<hour2){
        return -1;
      }else if( hour1> hour2){
        return 1;
      } else {
        //when hour equals
        if (min1 < min2){
          return -1;
        } else if( min1> min2){
          return 1;
        } else {
          return 0;
        }
      }
    } catch(err) {
      console.error(err)
      return 0;
    }

  }

  static dictToList<T>(dict:{[key:string]:T}):T[]{
    return Object.keys(dict).map(
      (patternId) => {
        const pattern = dict[patternId];
        (pattern as any).id = patternId;
        return pattern;
      }
    ).sort((a:any,b:any)=>{
      return (a.id as string).localeCompare(b.id);
    })
  }

  static dictToListSchedule<T>(dict:{[key:string]:ScheduledRing}):ScheduledRing[]{
    return Object.keys(dict).map(
      (id) => {
        const pattern = dict[id];
        (pattern as ScheduledRing).id = id;
        return pattern;
      }
    ).sort((a:ScheduledRing,b:ScheduledRing)=>{
      return this.compareRailwayTime(a.time,b.time);
    })
  }
}
